// Mirror of /app/backend/constants.py — keep these in sync.
// Driver rate bundles labour + overheads + target margin.
export const DRIVER_RATE_PER_PERSON_MONTH = 20000; // NZD per person-month

// Canonical hours per FTE per week.  data.meta.hoursPerFte (seeded from this
// constant in seed_constants.py) is the runtime source of truth — datasets
// may override it.  This export is the single Javascript-side canonical value.
export const HOURS_PER_FTE_WEEK = 40;

export const PROJECT_STATUSES = ["In Progress", "On Hold", "Potential", "Completed"];
export const RISK_FLAGS = [
  { id: "on_track",  label: "On track" },
  { id: "attention", label: "Needs principal attention" },
];
export const CONTRACT_VALUES = ["Yes", "Tentative"];
// Legacy "No" projects still display/behave as before — never presented as a
// selectable option any more (kept out of CONTRACT_VALUES so dropdowns hide it).
export const CONTRACT_VALUES_LEGACY = ["Yes", "Tentative", "No"];

// --- Profitability calculator thresholds (project form) ---
// Tunable in ONE place — the firm will likely adjust these once in use.
// Margin ($ and %) is green at/above this share of Total Fee, amber between
// zero and it, red when negative.
export const TARGET_MARGIN_THRESHOLD = 0.15; // 15% of Total Fee
// Revenue per person-month is green at/above this multiple of the firm's
// average monthly charge-out rate, amber between 1.0x and it, red below 1.0x.
export const TARGET_REVENUE_MULTIPLIER = 1.3;
// Hours-based personnel entries convert to person-months at this rate.
export const HOURS_PER_PERSON_MONTH = 160;
